import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  OnInit,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { InitializationService } from './shared/services/initialization.service';
import packageJson from '../../package.json';
import { AppModalService } from './shared/services/app-modal.service';
import { tap } from 'rxjs';
import { NgSelectConfig } from '@ng-select/ng-select';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements AfterViewInit, OnInit {
  private initializationService = inject(InitializationService);
  private appModalService = inject(AppModalService);
  private config = inject(NgSelectConfig);
  private destroyRef = inject(DestroyRef);

  // Reading the version from the package.json file
  public clientVersion: string = packageJson.version;
  isLoading = signal(true);
  @ViewChild('disconnectedDialog')
  disconnectedDialog!: ElementRef<HTMLDialogElement>;
  @ViewChild('activeCompanyDialog')
  activeCompanyDialog!: ElementRef<HTMLDialogElement>;

  constructor() {
    this.initializationService.initializeApp();
    this.config.appendTo = 'body';
  }

  ngOnInit(): void {
    // Prevent the escape key from closing the dialogs
    document.addEventListener(
      'keydown',
      (event: KeyboardEvent) => {
        if (event.key === 'Escape' && document.querySelector('dialog[open]')) {
          event.preventDefault();
        }
      },
      true
    );

    // Prevent mouse wheel scrolling from changing the value of a focused number input
    document.addEventListener(
      'wheel',
      () => {
        const activeElement = document.activeElement;
        if (activeElement instanceof HTMLInputElement && activeElement.type === 'number') {
          activeElement.blur();
        }
      },
      { passive: true }
    );

    this.initializationService
      .getInitUser()
      .pipe(
        tap(value => {
          if (value) {
            this.isLoading.set(false);
          }
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  ngAfterViewInit() {
    this.appModalService
      .getDisconnectedDialogSubject()
      .pipe(
        tap(() => {
          if (!this.disconnectedDialog.nativeElement.open) {
            this.disconnectedDialog.nativeElement.showModal();
          }
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
    this.appModalService
      .getActiveCompanyDialog()
      .pipe(
        tap(() => {
          if (!this.activeCompanyDialog.nativeElement.open) {
            this.activeCompanyDialog.nativeElement.showModal();
          }
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  reloadPage() {
    window.location.reload();
  }
}
